Modules.Conquesting = {};

Modules.Conquesting.Application = {
  insertConquest: function() {
    var el, length, pos;
    pos = Groupon.Conquest.position - 1;
    length = $("#coupons-list div.coupon").length - 1;
    if (pos >= length) {
      return false;
    }
    el = $("#coupons-list div.coupon:eq(" + pos + ")");
    $('.conquest').insertBefore(el);
  }
};

module.exports = Modules.Conquesting;

